import React from 'react'
import AboutSection from './AboutSection'
import ActualExamRehearsal from './ActualExamRehearsal'
import VisionMissionSection from './VisionMissionSection'
import PresenceStats from '../home/PresenceStats'

function About() {
  return (
    <>
    <AboutSection />
    <ActualExamRehearsal />
    <VisionMissionSection />
    <div className='mt-20'>
    <PresenceStats />
    </div>
    </>
  )
}

export default About